export default "__VITE_ASSET__DhrOJjJE__"